export const iconFontAwesomeUsersPeoplePersonThroughWindow = (
	<i className="fa-solid fa-person-through-window"></i>
);
